import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import {
  FaAddressCard,
  FaArrowRight,
  FaBell,
  FaBookOpen,
  FaCalendarAlt,
  FaCartPlus,
  FaChartBar,
  FaComment,
  FaCommentMedical,
  FaDesktop,
  FaDumbbell,
  FaEnvelope,
  FaExchangeAlt,
  FaFileSignature,
  FaHourglassHalf,
  FaImage,
  FaLayerGroup,
  FaMoneyBillWave,
  FaRegCreditCard,
  FaRegNewspaper,
  FaRocket,
  FaShoppingBag,
  FaUserCheck,
  FaUserCircle,
  FaUsers,
  FaVoteYea,
} from "react-icons/fa";

import { IoMdContacts, IoMdSettings } from "react-icons/io";
import {
  GiBlackBelt,
  GiGong,
  GiKimono,
  GiPodium,
  GiPodiumWinner,
} from "react-icons/gi";
import { MdDashboard, MdOutlineInventory, MdTimer } from "react-icons/md";
import { PiTranslateFill } from "react-icons/pi";
import { LuListTodo } from "react-icons/lu";
import { BsClipboardCheckFill } from "react-icons/bs";
import { RiQuestionnaireFill } from "react-icons/ri";
import { GrArticle } from "react-icons/gr";
import { AiFillHeart } from "react-icons/ai";

import Reveal from "../../components/Reveal/Reveal";
import MegaMenu from "./../Home/Navbar2/MegaMenu";

const MAX_SHORTCUTS = 8;
const PREFERRED_VIEW_KEY = "mac_preferred_view";

const DEFAULT_SHORTCUTS_BY_ROLE = {
  1: [
    "Dashboard Adhérents",
    "Dashboard Comptabilité",
    "Tableau de Bord",
    "Listing Adhérents Admin",
    "Règlements Inscriptions",
    "Dossiers d'Inscription Admin",
    "Paiements",
    "Paramètres",
  ],

  3: [
    "Listing Adhérents",
    "Appel Présence",
    "Passage Ceinture",
    "Événements",
    "Suivi Compétitions",
    "Palmarès",
    "Techniques Enseignants",
    "Catégories",
  ],

  2: [
    "Tableau de Bord",
    "Dossier d'Inscription",
    "Commandes & Règlements",
    "Fiche Adhérent",
    "Calendrier",
    "Messages",
    "Boutique",
    "Techniques Judo",
  ],
};

const DISPLAY_BY_LABEL = {
  Absences: "display_absences",
  Calendrier: "display_calendrier",
  Chat: "display_chat",
  Boutique: "display_boutique",
  "Commandes & Règlements": "display_commandes",
  "Prépa Physique": "display_prepa_physique",
  Actualités: "display_news",
  "Galerie Photos": "display_galerie",
  Lexique: "display_lexique",
  "Arbitrage Judo": "display_arbitrage",
  "Applications Judo": "display_applications",
  "Documents Passage Ceinture": "display_passage_ceinture_documents",
  "Techniques Judo": "display_techniques",
  "Techniques Quizz": "display_techniquesquizz",
  "Vote Sondage Utilisateur": "display_vote",

  "Appel Présence": "display_appels",
  "Tableau Appel": "display_tableauappel",
  "Passage Ceinture": "display_passage",
  "Grade CN": "display_gradecn",
  Événements: "display_evenements",
  "Prépa Physique Coaching": "display_prepa_physique_coaching",
  "Suivi Compétitions": "display_suivicompetition",
  Palmarès: "display_palmares",
  Objectifs: "display_objectifs",
  ToDoList: "display_todolist",
  "Techniques Enseignants": "display_techniquesenseignants",
  Catégories: "display_categories",

  "Articles Admin": "display_articlesadmin",
  "Dépenses Recettes": "display_depensesrecettes",
  Coachings: "display_coaching",
  "Heures Enseignement": "display_heures_enseignants",
  Inventaire: "display_inventaire",
  "Prêt Matériel": "display_pretmateriel",
  "Chat Page Admin": "display_chat_admin",
  "Message Admin": "display_messages_admin",
  "Vote Sondage Admin": "display_voteadmin",
  "Pages Personnalisées": "display_pagespersonnalisees",
};

const LINK_META = {
  "Tableau de Bord": {
    icon: <MdDashboard />,
    description: "Retour rapide à votre espace personnel.",
    tone: "from-blue-600 to-indigo-600",
  },
  "Dashboard Adhérents": {
    icon: <FaChartBar />,
    description: "Vue d’ensemble des adhérents du club.",
    tone: "from-blue-600 to-cyan-500",
  },
  "Dashboard Comptabilité": {
    icon: <FaMoneyBillWave />,
    description: "Suivi rapide des paiements et finances.",
    tone: "from-emerald-600 to-lime-500",
  },
  "Dossier d'Inscription": {
    icon: <FaAddressCard />,
    description: "Compléter ou consulter votre dossier.",
    tone: "from-orange-500 to-amber-500",
  },
  "Dossiers d'Inscription Admin": {
    icon: <FaFileSignature />,
    description: "Suivre les dossiers à contrôler.",
    tone: "from-orange-500 to-red-500",
  },
  "Fiche Adhérent": {
    icon: <FaUserCircle />,
    description: "Accéder à vos informations adhérent.",
    tone: "from-sky-600 to-blue-500",
  },
  Absences: {
    icon: <FaCommentMedical />,
    description: "Prévenir le club d’une absence.",
    tone: "from-rose-500 to-pink-500",
  },
  Calendrier: {
    icon: <FaCalendarAlt />,
    description: "Consulter les prochains rendez-vous.",
    tone: "from-indigo-600 to-violet-500",
  },
  Messages: {
    icon: <FaEnvelope />,
    description: "Lire vos messages reçus.",
    tone: "from-blue-600 to-sky-500",
  },
  Chat: {
    icon: <FaComment />,
    description: "Accéder aux conversations du club.",
    tone: "from-cyan-600 to-blue-500",
  },
  Boutique: {
    icon: <FaCartPlus />,
    description: "Voir les articles proposés par le club.",
    tone: "from-orange-500 to-yellow-500",
  },
  "Commandes & Règlements": {
    icon: <FaRegCreditCard />,
    description: "Consulter vos commandes et paiements.",
    tone: "from-emerald-600 to-teal-500",
  },
  "Règlements Inscriptions": {
    icon: <FaMoneyBillWave />,
    description: "Suivre les règlements à effectuer.",
    tone: "from-emerald-600 to-lime-500",
  },
  Paiements: {
    icon: <FaCartPlus />,
    description: "Suivre les paiements du club.",
    tone: "from-emerald-600 to-teal-500",
  },
  "Prépa Physique": {
    icon: <FaDumbbell />,
    description: "Retrouver les exercices de préparation.",
    tone: "from-red-600 to-orange-500",
  },
  "Prépa Physique Coaching": {
    icon: <FaDumbbell />,
    description: "Gérer les exercices des adhérents.",
    tone: "from-red-600 to-orange-500",
  },
  "Documents Passage Ceinture": {
    icon: <GiBlackBelt />,
    description: "Préparer les passages de grade.",
    tone: "from-slate-700 to-slate-950",
  },
  "Passage Ceinture": {
    icon: <GiBlackBelt />,
    description: "Gérer les passages de ceinture.",
    tone: "from-slate-700 to-slate-950",
  },
  "Grade CN": {
    icon: <GiBlackBelt />,
    description: "Suivre les grades ceinture noire.",
    tone: "from-slate-800 to-black",
  },
  "Techniques Judo": {
    icon: <GiKimono />,
    description: "Réviser les techniques de judo.",
    tone: "from-blue-700 to-slate-900",
  },
  "Techniques Enseignants": {
    icon: <GiKimono />,
    description: "Accéder aux contenus enseignants.",
    tone: "from-blue-700 to-slate-900",
  },
  "Techniques Quizz": {
    icon: <GiKimono />,
    description: "Tester ses connaissances techniques.",
    tone: "from-violet-600 to-indigo-600",
  },
  "Vote Sondage Utilisateur": {
    icon: <FaVoteYea />,
    description: "Participer aux votes ouverts.",
    tone: "from-purple-600 to-pink-500",
  },
  "Vote Sondage Admin": {
    icon: <FaVoteYea />,
    description: "Piloter les votes et sondages.",
    tone: "from-purple-600 to-pink-500",
  },
  Actualités: {
    icon: <FaRegNewspaper />,
    description: "Lire les dernières actualités du club.",
    tone: "from-sky-600 to-indigo-500",
  },
  Lexique: {
    icon: <PiTranslateFill />,
    description: "Consulter le vocabulaire judo.",
    tone: "from-amber-500 to-orange-500",
  },
  "Arbitrage Judo": {
    icon: <GiGong />,
    description: "Accéder aux ressources d’arbitrage.",
    tone: "from-red-600 to-slate-900",
  },
  "Galerie Photos": {
    icon: <FaImage />,
    description: "Voir les albums photos du club.",
    tone: "from-pink-500 to-rose-500",
  },
  "Listing Adhérents": {
    icon: <IoMdContacts />,
    description: "Retrouver rapidement les adhérents.",
    tone: "from-blue-600 to-cyan-500",
  },
  "Listing Utilisateurs": {
    icon: <FaUsers />,
    description: "Gérer les comptes utilisateurs.",
    tone: "from-indigo-600 to-blue-500",
  },
  "Listing Adhérents Admin": {
    icon: <FaUsers />,
    description: "Administrer la liste des adhérents.",
    tone: "from-blue-600 to-cyan-500",
  },
  "Appel Présence": {
    icon: <FaUserCheck />,
    description: "Faire l’appel pendant les cours.",
    tone: "from-emerald-600 to-green-500",
  },
  "Tableau Appel": {
    icon: <BsClipboardCheckFill />,
    description: "Voir les présences et absences.",
    tone: "from-teal-600 to-emerald-500",
  },
  Événements: {
    icon: <FaCalendarAlt />,
    description: "Créer ou suivre les événements.",
    tone: "from-indigo-600 to-violet-500",
  },
  "Suivi Compétitions": {
    icon: <GiPodiumWinner />,
    description: "Suivre les compétitions des judokas.",
    tone: "from-yellow-500 to-orange-500",
  },
  Palmarès: {
    icon: <GiPodium />,
    description: "Consulter les résultats sportifs.",
    tone: "from-yellow-500 to-amber-500",
  },
  ToDoList: {
    icon: <LuListTodo />,
    description: "Suivre les tâches importantes.",
    tone: "from-slate-700 to-blue-700",
  },
  "Aide Enseignants": {
    icon: <RiQuestionnaireFill />,
    description: "Retrouver les ressources utiles.",
    tone: "from-violet-600 to-indigo-600",
  },
  "Articles Admin": {
    icon: <FaShoppingBag />,
    description: "Gérer les articles de la boutique.",
    tone: "from-orange-500 to-amber-500",
  },
  "Dépenses Recettes": {
    icon: <FaMoneyBillWave />,
    description: "Gérer les finances du club.",
    tone: "from-emerald-600 to-lime-500",
  },
  Coachings: {
    icon: <MdTimer />,
    description: "Suivre les séances de coaching.",
    tone: "from-red-600 to-orange-500",
  },
  "Heures Enseignement": {
    icon: <FaHourglassHalf />,
    description: "Suivre les heures d’enseignement.",
    tone: "from-cyan-600 to-blue-500",
  },
  Inventaire: {
    icon: <MdOutlineInventory />,
    description: "Consulter le matériel du club.",
    tone: "from-slate-600 to-slate-900",
  },
  "Message Admin": {
    icon: <FaEnvelope />,
    description: "Lire les messages administratifs.",
    tone: "from-blue-600 to-sky-500",
  },
  "Pages Personnalisées": {
    icon: <GrArticle />,
    description: "Gérer les pages du site.",
    tone: "from-indigo-600 to-blue-500",
  },
  Paramètres: {
    icon: <IoMdSettings />,
    description: "Configurer l’application du club.",
    tone: "from-slate-700 to-slate-950",
  },
  Abonnement: {
    icon: <FaRegCreditCard />,
    description: "Consulter l’abonnement du club.",
    tone: "from-emerald-600 to-teal-500",
  },
};

const DASHBOARD_PATH_BY_LABEL = {
  "Tableau de Bord": "/dashboard/tableau-de-bord",
  "Dashboard Adhérents": "/dashboard/dashboard-adherents",
  "Dashboard Comptabilité": "/dashboard/dashboard-comptabilite",
  "Listing Utilisateurs": "/dashboard/listing-utilisateurs",
  "Listing Adhérents Admin": "/dashboard/listing-adherents-admin",
  "Règlements Inscriptions": "/dashboard/reglements-inscriptions",
  "Dossiers d'Inscription Admin": "/dashboard/dossiers-d-inscription",
  "Articles Admin": "/dashboard/articles-admin",
  "Dépenses Recettes": "/dashboard/depenses-recettes",
  Paramètres: "/dashboard/parametres",
  "Dossier d'Inscription": "/dashboard/dossier-d-inscription",
  "Commandes & Règlements": "/dashboard/commandes-&-reglements",
  "Fiche Adhérent": "/dashboard/fiche-adherent",
  Calendrier: "/dashboard/calendrier",
  Messages: "/dashboard/messages",
  Paiements: "/dashboard/paiements",
  "Suivi Compétitions": "/dashboard/suivi-competitions",
  Absences: "/dashboard/absences",
  Boutique: "/dashboard/boutique",
  "Prépa Physique": "/dashboard/prepa-physique",
  Actualités: "/dashboard/actualites",
  "Galerie Photos": "/dashboard/galerie-photos",
  Lexique: "/dashboard/lexique",
  "Arbitrage Judo": "/dashboard/arbitrage-judo",
  "Applications Judo": "/dashboard/applications-judo",
  "Documents Passage Ceinture": "/dashboard/documents-passage-ceinture",
  "Techniques Judo": "/dashboard/techniques-judo",
  "Techniques Quizz": "/dashboard/techniques-quizz",
  "Vote Sondage Utilisateur": "/dashboard/vote-sondage-utilisateur",
  "Appel Présence": "/dashboard/appel-presence",
  "Listing Adhérents": "/dashboard/listing-adherents",
  "Passage Ceinture": "/dashboard/passage-ceinture",
  "Tableau Appel": "/dashboard/tableau-appel",
  "Grade CN": "/dashboard/grade-cn",
  Événements: "/dashboard/evenements",
  "Prépa Physique Coaching": "/dashboard/prepa-physique-coaching",
  Palmarès: "/dashboard/palmares",
  Objectifs: "/dashboard/objectifs",
  ToDoList: "/dashboard/todolist",
  "Techniques Enseignants": "/dashboard/techniques-enseignants",
  Catégories: "/dashboard/categories",
  "Aide Enseignants": "/dashboard/aide-enseignants",
  "Détails Adhérent": "/dashboard/details-adherent",
  "Heures Enseignement": "/dashboard/heures-enseignement",
  Coachings: "/dashboard/coachings",
  Inventaire: "/dashboard/inventaire",
  "Prêt Matériel": "/dashboard/pret-materiel",
  "Chat Page Admin": "/dashboard/message-admin",
  "Message Admin": "/dashboard/message-admin",
  "Vote Sondage Admin": "/dashboard/vote-sondage-admin",
  "Pages Personnalisées": "/dashboard/pages-personnalisees",
  "Requêtes Admin": "/dashboard/requetes-admin",
  Abonnement: "/dashboard/abonnement",
  Update: "/dashboard/update",
  "Aide Conseils": "/dashboard/aide-conseils",
};

const COUNTER_KEYS_BY_LABEL = {
  "Dashboard Adhérents": ["newMembersToday", "latestMembersToday"],

  Messages: ["messages", "unreadMessages", "unreadMessageCount"],

  Notifications: ["notifications", "unreadNotifications", "unreadCount"],
  "Tableau de Bord": ["notifications", "unreadNotifications", "unreadCount"],

  "Message Admin": ["contactForms", "adminMessages", "unreadCountContactForm"],
  "Messages du formulaire": [
    "contactForms",
    "adminMessages",
    "unreadCountContactForm",
  ],

  "Commandes & Règlements": ["payments", "orders", "pendingPayments"],
  "Règlements Inscriptions": [
    "payments",
    "registrationsPayments",
    "pendingPayments",
  ],
  Paiements: ["payments", "pendingPayments"],
  Boutique: ["orders", "cart", "pendingOrders"],
  Absences: ["absences", "pendingAbsences"],
  "Vote Sondage Utilisateur": ["votes", "openVotes"],
  "Vote Sondage Admin": ["votes", "openVotes"],
  "Dossiers d'Inscription Admin": ["registrationFiles", "pendingRegistrations"],
  "Dossier d'Inscription": ["registrationFiles", "pendingRegistrations"],
};

const coerceBool = (val, fallback = true) => {
  if (val === undefined || val === null) return fallback;
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val !== 0;

  if (typeof val === "string") {
    const v = val.trim().toLowerCase();

    if (["true", "1", "yes", "on"].includes(v)) return true;
    if (["false", "0", "no", "off"].includes(v)) return false;
  }

  return !!val;
};

const coerceCount = (value) => {
  const count = Number(value);

  if (!Number.isFinite(count) || count <= 0) return 0;

  return Math.floor(count);
};

const getRoleId = (user) => {
  const raw =
    user?.role_id ||
    user?.roleId ||
    user?.roleID ||
    user?.Role?.id ||
    user?.role?.id ||
    user?.role;

  const numeric = Number(raw);

  if (Number.isFinite(numeric)) return numeric;

  const label = String(raw || "").toLowerCase();

  if (label.includes("admin")) return 1;
  if (label.includes("enseign")) return 3;

  return 2;
};

const getUserDisplayName = (user) => {
  return (
    `${user?.prenom || ""} ${user?.nom || ""}`.trim() ||
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
    user?.nom_complet ||
    user?.name ||
    user?.email ||
    "Utilisateur"
  );
};

const safeReadJSON = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const parsed = JSON.parse(raw);

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const uniqueLabels = (labels = []) => {
  const seen = new Set();

  return labels
    .filter(Boolean)
    .map((label) => String(label).trim())
    .filter((label) => {
      if (!label || seen.has(label)) return false;

      seen.add(label);
      return true;
    });
};

const readStoredFavorites = ({ roleId, userId }) => {
  const keys = [
    userId ? `home_shortcuts_favorites_${userId}` : null,
    `home_shortcuts_favorites_${roleId}`,
    `megamenu_favorites_${roleId || "guest"}`,
  ].filter(Boolean);

  for (const key of keys) {
    const values = uniqueLabels(safeReadJSON(key));

    if (values.length > 0) return values;
  }

  return [];
};

const getClassicPathFromLabel = (label) => {
  return `/${String(label)
    .toLowerCase()
    .replace(/[\s'ç]/g, "-")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")}`;
};

const getInitialPreferredView = () => {
  try {
    const stored = localStorage.getItem(PREFERRED_VIEW_KEY);

    if (stored === "dashboard" || stored === "classic") return stored;

    if (
      typeof window !== "undefined" &&
      window.matchMedia?.("(min-width: 1024px)")?.matches
    ) {
      return "dashboard";
    }

    return "classic";
  } catch {
    return "classic";
  }
};

const getCounterForLabel = ({ label, countsByLabel, counters }) => {
  const direct = countsByLabel?.[label];

  if (direct !== undefined && direct !== null) {
    return coerceCount(direct);
  }

  const keys = COUNTER_KEYS_BY_LABEL[label] || [];

  for (const key of keys) {
    const value = counters?.[key];

    if (value !== undefined && value !== null) {
      return coerceCount(value);
    }
  }

  return 0;
};

function ShortcutCounterBadge({ count }) {
  if (!count) return null;

  return (
    <span className="absolute right-0 top-0 z-20 flex min-h-[22px] min-w-[22px] items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold leading-none text-white shadow-lg ring-3 ring-white dark:ring-slate-950 sm:-right-1 sm:-top-1 sm:min-h-[24px] sm:min-w-[24px] sm:text-[11px]">
      {count > 99 ? "99+" : count}
    </span>
  );
}

function ViewToggle({ value, active, icon, label, description, onClick }) {
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className={`group flex min-w-0 items-center gap-2 rounded-2xl border px-2.5 py-2 text-left transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg sm:gap-3 sm:px-4 sm:py-3 ${
        active
          ? "border-primary bg-primary text-white shadow-md"
          : "border-slate-200 bg-white/80 text-slate-700 hover:bg-white dark:border-white/10 dark:bg-white/5 dark:text-slate-200 dark:hover:bg-white/10"
      }`}
    >
      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl text-sm sm:h-10 sm:w-10 sm:text-lg ${
          active
            ? "bg-white/20 text-white"
            : "bg-slate-100 text-primary dark:bg-white/10"
        }`}
      >
        {icon}
      </span>

      <span className="min-w-0">
        <span className="block truncate text-xs font-bold sm:text-sm">
          {label}
        </span>

        <span
          className={`mt-0.5 block truncate text-[10px] leading-none sm:text-xs ${
            active ? "text-white/80" : "text-slate-500 dark:text-slate-400"
          }`}
        >
          {description}
        </span>
      </span>
    </button>
  );
}

function ShortcutCard({ shortcut, preferredView, count }) {
  const meta = LINK_META[shortcut] || {
    icon: <FaLayerGroup />,
    description: "Accéder rapidement à cette page.",
    tone: "from-slate-700 to-slate-950",
  };

  const dashboardPath = DASHBOARD_PATH_BY_LABEL[shortcut];
  const path =
    preferredView === "dashboard" && dashboardPath
      ? dashboardPath
      : getClassicPathFromLabel(shortcut);

  const targetLabel =
    preferredView === "dashboard" && dashboardPath ? "Dashboard" : "Classique";

  return (
    <Link
      to={path}
      className="group relative flex min-h-[152px] overflow-hidden rounded-[1.8rem] border border-slate-200 bg-white p-4 text-slate-950 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 dark:border-white/10 dark:bg-slate-900 dark:text-white sm:min-h-[168px]"
    >
      <div
        className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${meta.tone}`}
      />

      <div
        className={`pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-gradient-to-br ${meta.tone} opacity-10 blur-2xl transition-opacity duration-300 group-hover:opacity-20`}
      />

      <div className="relative z-10 flex w-full flex-col">
        <div className="flex items-start justify-between gap-2 sm:gap-3">
          <span className="relative flex h-16 w-16 shrink-0 items-start justify-start">
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${meta.tone} text-xl text-white shadow-lg shadow-slate-900/10 transition-transform duration-300 group-hover:scale-110 sm:h-14 sm:w-14 sm:text-2xl`}
            >
              {meta.icon}
            </span>

            <ShortcutCounterBadge count={count} />
          </span>

          <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500 dark:bg-white/10 dark:text-slate-300">
            {targetLabel}
          </span>
        </div>

        <div className="mt-4 min-w-0 flex-1">
          <h3 className="font-barlow text-base font-bold leading-tight text-slate-950 dark:text-white sm:text-lg">
            {shortcut}
          </h3>

          <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-500 dark:text-slate-400 sm:text-sm">
            {meta.description}
          </p>
        </div>

        <div className="mt-4 flex items-center justify-between gap-3">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary">
            Ouvrir
          </span>

          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition-all duration-300 group-hover:translate-x-1 group-hover:bg-primary group-hover:text-white dark:bg-white/10 dark:text-white">
            <FaArrowRight />
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function HomeUserShortcuts({
  user,
  settings,
  counters = {},
  countsByLabel = {},
  countersLoading = false,
  countersErrorMsg = "",
  onRefreshCounters,
  className = "",
}) {
  const roleId = useMemo(() => getRoleId(user), [user]);
  const userId = user?.id || user?.user_id || user?.uid || "";
  const userName = useMemo(() => getUserDisplayName(user), [user]);

  const [storedFavorites, setStoredFavorites] = useState([]);
  const [preferredView, setPreferredView] = useState(getInitialPreferredView);

  const [megaMenuOpen, setMegaMenuOpen] = useState(false);

  useEffect(() => {
    if (!megaMenuOpen) return undefined;

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMegaMenuOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [megaMenuOpen]);

  useEffect(() => {
    if (!user) return undefined;

    const refreshFavorites = () => {
      setStoredFavorites(readStoredFavorites({ roleId, userId }));
    };

    refreshFavorites();

    window.addEventListener("storage", refreshFavorites);
    window.addEventListener("mac:favorites-updated", refreshFavorites);

    return () => {
      window.removeEventListener("storage", refreshFavorites);
      window.removeEventListener("mac:favorites-updated", refreshFavorites);
    };
  }, [roleId, user, userId]);

  const shortcuts = useMemo(() => {
    const defaultShortcuts =
      DEFAULT_SHORTCUTS_BY_ROLE[roleId] || DEFAULT_SHORTCUTS_BY_ROLE[2];

    const source =
      storedFavorites.length > 0 ? storedFavorites : defaultShortcuts;

    return uniqueLabels(source)
      .filter((label) => {
        const displayKey = DISPLAY_BY_LABEL[label];

        if (!displayKey) return true;

        return coerceBool(settings?.[displayKey], true);
      })
      .slice(0, MAX_SHORTCUTS);
  }, [roleId, settings, storedFavorites]);

  const hasCustomFavorites = storedFavorites.length > 0;

  const totalCounters = useMemo(() => {
    return shortcuts.reduce((total, label) => {
      return (
        total +
        getCounterForLabel({
          label,
          counters,
          countsByLabel,
        })
      );
    }, 0);
  }, [counters, countsByLabel, shortcuts]);

  const handlePreferredViewChange = (nextView) => {
    const safeView = nextView === "dashboard" ? "dashboard" : "classic";

    try {
      localStorage.setItem(PREFERRED_VIEW_KEY, safeView);
    } catch {}

    setPreferredView(safeView);
  };

  if (!user) return null;

  return (
    <section
      id="mes-raccourcis"
      className={`relative overflow-hidden bg-slate-50 py-8 text-slate-950 dark:bg-slate-950 dark:text-white sm:py-14 lg:py-20 ${className}`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,113,49,0.14),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(1,62,142,0.16),transparent_34%)]" />

      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(148,163,184,0.14)_1px,transparent_1px),linear-gradient(to_bottom,rgba(148,163,184,0.14)_1px,transparent_1px)] bg-[size:42px_42px] opacity-35 dark:opacity-20" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-orange-700 shadow-sm dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
            <FaRocket />
            Espace connecté
          </div>

          <h2 className="mt-4 font-barlow text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:mt-6 sm:text-5xl lg:text-6xl">
            Bonjour{" "}
            <span className="text-primary">
              {userName.split(" ")[0] || "judoka"}
            </span>
          </h2>

          <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-600 dark:text-slate-300 sm:mt-5 sm:text-base sm:leading-8">
            Retrouvez immédiatement vos pages MonAppliClub les plus utiles, avec
            les alertes importantes du moment.
          </p>
        </Reveal>

        <Reveal
          delay={80}
          className="mx-auto mt-6 grid max-w-4xl grid-cols-2 gap-2 sm:mt-10 sm:gap-3"
        >
          <ViewToggle
            value="classic"
            active={preferredView === "classic"}
            icon={<FaExchangeAlt />}
            label="Vue classique"
            description="Smartphone"
            onClick={handlePreferredViewChange}
          />

          <ViewToggle
            value="dashboard"
            active={preferredView === "dashboard"}
            icon={<FaDesktop />}
            label="Vue dashboard"
            description="Ordinateur"
            onClick={handlePreferredViewChange}
          />
        </Reveal>

        <Reveal
          delay={120}
          className="mx-auto mt-5 grid max-w-4xl grid-cols-3 gap-2 sm:mt-8 sm:gap-4"
        >
          <div className="rounded-2xl border border-slate-200 bg-white/80 px-2 py-3 text-center shadow-sm backdrop-blur-xl dark:border-white/10 dark:bg-white/5 sm:rounded-[1.7rem] sm:p-5">
            <AiFillHeart className="mx-auto mb-1.5 text-base text-primary sm:mb-3 sm:text-2xl" />

            <p className="font-barlow text-xl font-bold leading-none text-slate-950 dark:text-white sm:text-3xl">
              {shortcuts.length}
            </p>

            <p className="mt-1 truncate text-[9px] font-bold uppercase tracking-[0.12em] text-slate-400 sm:text-xs sm:tracking-[0.18em]">
              Raccourcis
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white/80 px-2 py-3 text-center shadow-sm backdrop-blur-xl dark:border-white/10 dark:bg-white/5 sm:rounded-[1.7rem] sm:p-5">
            <FaBell className="mx-auto mb-1.5 text-base text-primary sm:mb-3 sm:text-2xl" />

            <p className="font-barlow text-xl font-bold leading-none text-slate-950 dark:text-white sm:text-3xl">
              {countersLoading
                ? "…"
                : totalCounters > 99
                  ? "99+"
                  : totalCounters}
            </p>

            <p className="mt-1 truncate text-[9px] font-bold uppercase tracking-[0.12em] text-slate-400 sm:text-xs sm:tracking-[0.18em]">
              Alertes
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white/80 px-2 py-3 text-center shadow-sm backdrop-blur-xl dark:border-white/10 dark:bg-white/5 sm:rounded-[1.7rem] sm:p-5">
            <FaBookOpen className="mx-auto mb-1.5 text-base text-primary sm:mb-3 sm:text-2xl" />

            <p className="font-barlow text-xl font-bold leading-none text-slate-950 dark:text-white sm:text-3xl">
              {hasCustomFavorites ? "Perso" : "Auto"}
            </p>

            <p className="mt-1 truncate text-[9px] font-bold uppercase tracking-[0.12em] text-slate-400 sm:text-xs sm:tracking-[0.18em]">
              Favoris
            </p>
          </div>
        </Reveal>

        <Reveal delay={180}>
          <div className="mx-auto mt-8 max-w-4xl rounded-[1.5rem] border border-slate-200 bg-white/70 px-5 py-4 text-center text-sm leading-6 text-slate-500 shadow-sm backdrop-blur-xl dark:border-white/10 dark:bg-white/5 dark:text-slate-400">
            {hasCustomFavorites ? (
              <>
                Ces raccourcis proviennent de vos favoris enregistrés dans le
                menu principal (Bouton Application).
              </>
            ) : (
              <>
                Aucun favori personnalisé n’est encore enregistré. MonAppliClub
                affiche donc une sélection automatique adaptée à votre rôle.
              </>
            )}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4">
          {shortcuts.map((shortcut, index) => (
            <Reveal
              key={`${shortcut}-${index}`}
              variant="zoom"
              delay={index * 55}
            >
              <ShortcutCard
                shortcut={shortcut}
                preferredView={preferredView}
                count={getCounterForLabel({
                  label: shortcut,
                  counters,
                  countsByLabel,
                })}
              />
            </Reveal>
          ))}
        </div>

        <Reveal delay={170}>
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:mt-8 sm:flex-row">
            <button
              type="button"
              onClick={() => setMegaMenuOpen(true)}
              className="group inline-flex w-full items-center justify-center gap-3 rounded-2xl bg-slate-950 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-slate-900/10 transition hover:-translate-y-0.5 hover:bg-primary hover:shadow-xl dark:bg-white dark:text-slate-950 dark:hover:bg-primary dark:hover:text-white sm:w-auto"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-primary transition group-hover:bg-white/20 group-hover:text-white dark:bg-slate-950/10 dark:group-hover:bg-white/20">
                <FaLayerGroup />
              </span>

              <span>Voir toutes les pages / Gérer les favoris</span>

              <FaArrowRight className="text-xs transition group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>

        
      </div>
      {megaMenuOpen && (
        <div className="fixed inset-0 z-[9999] flex items-start justify-center overflow-y-auto bg-slate-950/70 px-3 py-4 backdrop-blur-sm sm:px-6 sm:py-8">
          <button
            type="button"
            aria-label="Fermer le menu"
            className="absolute inset-0 cursor-default"
            onClick={() => setMegaMenuOpen(false)}
          />

          <div className="relative z-10 w-full max-w-[1280px]">
            <MegaMenu
              role_id={roleId}
              settings={settings}
              closeMegaMenu={() => setMegaMenuOpen(false)}
              onClose={() => setMegaMenuOpen(false)}
            />
          </div>
        </div>
      )}
    </section>
  );
}
